module.exports = __webpack_public_path__ + "7240d5b36051d21601198378d6e2d4c8.png";